import { render } from "./KoruBlock.vue?vue&type=template&id=04fe295c&ts=true"
import script from "./KoruBlock.vue?vue&type=script&lang=ts"
export * from "./KoruBlock.vue?vue&type=script&lang=ts"

import "./KoruBlock.vue?vue&type=style&index=0&id=04fe295c&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__